module.exports = __webpack_public_path__ + "e8d05c41a6966b42f291ee85bf6fb598.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/lifeQuestionQ4.mp4
// module id = 413
// module chunks = 0